import { useQuery } from 'react-query';
import { post } from '../fetch';
// Note: Stocks does not support preview, so we dont add preview date to requests

export const createCacheKey = (
  key: string,
  request: IItemStockRequest,
): (string | number | undefined)[] => {
  return [
    key,
    request.m3Id,
    request.moderArtikelId,
    request.configurationId,
    request.variantId,
    request.quantity,
  ];
};

const stockKeys = {
  storeStockQuery: (store: string = '', request: IItemStockRequest) =>
    createCacheKey(store, request),
  stockQuery: (request: IItemStockRequest) => createCacheKey('stock', request),
  leadTimeQuery: (request: IItemStockRequest) => createCacheKey('lead-time', request),
};

export const useStoreStockQuery = (
  request: IItemStockRequest,
  store?: string,
  disabled?: boolean,
) => {
  return useQuery(
    stockKeys.storeStockQuery(store, request),
    () =>
      post<IItemStockStatus, IItemStockRequest>(
        `/bff/api/stock/check-stock-only/${store}`,
        request,
      ),
    { enabled: !disabled },
  );
};

export const useStockQuery = (request: IItemStockRequest) => {
  return useQuery(stockKeys.stockQuery(request), () =>
    post<Record<string, IItemStockStatus>, IItemStockRequest>(
      `/bff/api/stock/check-stock-only`,
      request,
    ),
  );
};

// For getting lead time across all stores
export const useLeadTimeQuery = (request: IItemStockRequest, suspense: boolean = false) => {
  return useQuery(
    stockKeys.leadTimeQuery(request),
    () =>
      post<{ minDeliveryDays: number; maxDeliveryDays: number }, IItemStockRequest>(
        `/bff/api/stock/lead-time`,
        request,
      ),
    { suspense },
  );
};
